import { createFileRoute, notFound } from "@tanstack/react-router";
import { pageTitle } from "@/config/site";
import { getStaticPage } from "@/lib/pages";
import { localeUrl } from "@/lib/seo";
import { StaticMdxPage } from "@/components/static-mdx-page";

const SLUG = "faq";

export const Route = createFileRoute("/$locale/faq")({
  loader: async ({ params }) => {
    try {
      return await getStaticPage({ data: { slug: SLUG, locale: params.locale } });
    } catch {
      throw notFound();
    }
  },
  head: ({ loaderData, params }) => {
    const meta = loaderData?.meta;
    const canonicalUrl = localeUrl(params.locale, "/faq");
    return {
      meta: [
        { title: pageTitle(meta?.title ?? "FAQ") },
        { name: "description", content: meta?.description ?? "Frequently asked questions about TianPan.co" },
        { property: "og:title", content: pageTitle(meta?.title ?? "FAQ") },
        { property: "og:url", content: canonicalUrl },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: function StaticRoute() {
    const { code } = Route.useLoaderData();
    return <StaticMdxPage code={code} />;
  },
});
